import React from 'react';
import * as Styles from 'pages/function2-result/styles';
import coinplug_logo from 'assets/coinplug-logo-horizo.png';
import { TextForm, ResultBox } from 'components';
import parseQueryAndVerifyAuth from '../../service/parseQueryAndVerifyAuth';
import config from '../../config';

const type = config.mykeepin.authType.function2;

// Page function2 (페이지명은 추후에 바뀔 수 있음)
class function2_result extends React.Component {
  // Page state
  state = {
    statusCode: '',
    verificationResult: false,
    description: '',
    decryptedVp: { message: 'Loading' },
    personalData: { message: 'Loading' },
  }

  // Render page
  render() {
    return (
      <Styles.PageLayout>
        <Styles.GridLayout>
          {/* 결과 출력하는 영역 제외한 부분 */}
          <Styles.LeftSideLayout>
            {/* coinplug logo */}
            <Styles.LogoContainer>
              <Styles.Logo src={coinplug_logo} alt="coinplug-logo" />
            </Styles.LogoContainer>

            {/* 페이지 title */}
            <Styles.PageTitle>
              VP SAMPLE
            </Styles.PageTitle>

            {/* 샘플 텍스트 */}
            <Styles.Paragraph>
              Metadium DID 기반 인증 서비스를 테스트합니다. 본 테스트는 VP를 요청하는 Type을 사용하기 때문에, 인증한 유저에게 개인정보를 받아옵니다. 인증 Code 값을 검증하면 인증한 유저의 DID 값, Signature 값, 그리고 사전에 등록된 Pubkey 로 암호화된 VP를 받습니다.
            </Styles.Paragraph>
          </Styles.LeftSideLayout>
          {/* 결과 출력하는 박스 */}
          <Styles.ResultBoxContainer>
            <ResultBox
              style={{ width: "100%", height: "100%" }}
              status={this.state.verificationResult}
              status_code={this.state.statusCode}
              description={this.state.description}
              icon_margin={"56px"}
            >
              <TextForm
                style={{ margin: "76px 32px 24px 32px" }}
                header="Decrypted VP"
                placeholder={JSON.stringify(this.state.decryptedVp, null, 4)}
                pre={true}
              />
              <TextForm
                style={{ margin: "0px 32px 24px 32px" }}
                header="Personal Data"
                placeholder={JSON.stringify(this.state.personalData, null, 4)}
                pre={true}
              />
            </ResultBox>
          </Styles.ResultBoxContainer>
        </Styles.GridLayout>
      </Styles.PageLayout>
    )
  }

  // Call local api and fetch decrypted_vp & personal_data
  async componentDidMount() {
    const res = await parseQueryAndVerifyAuth.call(this, type, '')
    if (res) {
      const { vp, claims } = res;
      this.setState({
        decryptedVp: vp,
        personalData: claims,
      });
    } else {
      this.setState({
        decryptedVp: { msg: 'No personal data found' },
        personalData: { msg: 'No personal data found' },
      })
    }
  }
}

export default function2_result;